export default {
  "你好，请登录": "Заходите, пожалуйста",
  "免费注册": "Бесплатная регистрация.",
  "你好": "Здравствыйте",
  "退出": "выход",
  "个人中心": "Личный центр",
  "我的订单": "Мой приказ.",
  "优惠券": "Купоны.",
  "我的发票": "Мой счет.",
  "BOM需求": "Требования бум",
  "账号管理": "Управление счетом",
  "我的收货地址": "Мой адрес доставки",
  "我的积分": "Мои очки.",
  "我的足迹": "Мои следы.",
  "QQ咨询": "Консультация кью.",
  "客服": "Служб поддержк",
  "收藏网址": "Сайт коллекции",
  "商户后台": "Кулисы предприятия",
  "退出提示": "Выход.",
  "是否确认退出": "Подтверждаю ли выход?",
  "取 消": "За исключ",
  "确 定": ",.",
  "骏芯商城": "Деловой город ядзаки",
  "请输入内容": "Введите, пожалуйста.",
  "全部商品": "Все товары.",
  "骏芯自营": "Ядрёные ядра",
  "爆款推荐": "Рекомендации по взрыву.",
  "成品方案": "Программа готовой продукции",
  "简体中文": "китайск",
  "英语": "По-английск",
  "俄语": "русск",
  "Hi,上午好": "Доброе утро",
  "欢迎来到骏芯商城": "Добро пожаловать в Junxin",
  "登录": "залогин",
  "注册": "зарегистрирова",
  "全部商品分类": "категории",
  "现货库存": "спот",
  "爆款推荐": "ходкий",
  "热": "Горячий",
  "骏芯秒杀": "Краткосрочная скидка",
  "爆": "Горячий",
  "镜头模组": "Модуль камеры",
  "成品方案": "Схема",
  "兑换专区": "обмен",
  "技术论坛": "форумHDI",
  "HDI板": "HDI",
  "入驻骏芯": "Поселились",
  "加入": "вступать",
  "专业元器件交易商城": "",
  "原装正品·服务优质·供应稳定": "",
  "请输入需要搜索的内容": "Пожалуйста, введите то, что необходимо для поиска",
  "极速BOM配单": "перечень",
  "BOM文件上传": "Загрузка файлов",
  "点击上传Excel文件": "закачать",
  "点击上传图片": "изображение",
  "BOM标准模板下载": "Загрузка шаблонов",
  "下载": "загрузк",
  "我的订单": "Мой приказ.",
  "查看我的订单": "Вид",
  "已签到": "Подписан",
  "点击签到": "Нажмите на регистрацию",
  "签到": "расписа",
  "连续签到": "",
  "天": "дне",
  "签到领积分": "интеграл",
  "成交记录": " Запись",
  "全部成交": "шт.",
  "单": "",
  "积分商城": "Пойнтс Молл",
  "积分兑换": "Обмен",
  "热门型号": "Модель номер Один.",
  "TOP": "TOP",
  "榜": "Hot",
  "扫微信二维码咨询客服": "Консультативная служба по обслуживанию клиентов",
  "二维码": "Двумерный код.",
  "客户经理": "Менеджер клиента",
  "在线客服电话": "Телефон службы поддержки",
  "在线客服QQ": "Онлайн служба поддержки клиентов QQ",
  "工作时间": "Время работы.",
  "投诉电话": "Жалобный звонок",
  "咨询客服": "",
  "购物车": "",
  "优惠劵": "",
  "足迹": "",
  "投诉": "",
  "顶部": "",
  "意见反馈": "Обратная связь мнений",
  "关于我们": "О нас. ",
  "好":"x",
  "海量现货": "Массовые запасы",
  "40万现货SKU": "40 0000 SKU",
  "品类不断扩充": "Ассортимент постоянно расширяется",
  "快": "Б",
  "闪电发货": "Молниеносная доставка.",
  "科技智能大仓储": "Научно-технический интеллект",
  "4小时快速交货": "4 часа на быструю доставку",
  "好": "x",
  "严控渠道": "Канал строгого контроля",
  "仅从原厂和代理商进货": "Закупается только на заводах и агентах",
  "每一颗料均可原厂追溯": "Каждый ингредиент можно проследить с завода",
  "省": "Э",
  "降低成本": "Снижать расходы",
  "明码标价节省时间成本": "Цена на код экономит время",
  "一站式采购正品元器件": "Одноместный закупка подлинных предметов",
  "联系我们": "Свяжись с нами.",
  "企业QQ": "Корпоративный QQ",
  "服务时间：24小时在线": "Время службы: 24 часа онлайн",
  "2011-2022 骏芯有限公司 版权所有": "Авторские права компании 'ядзин яо' 2011-2022",


   
"上一张":"Последний.",
"下一张":"Следующий.",
//addAddress.vue
"选择收货地址":"Please select the shipping address",
"收":"за",
"默认地址":"По умолчанию",
"+新增收货地址":"+Добавить адрес",
"收货地址":"Адрес доставки",
"所在区域":"Регион",
"请选择活动区域":"Пожалуйста, выберите зону действия",
"详细地址":"Полный адрес",
"无需重复填写省市区，小于75个字":"Нет необходимости повторно заполнять провинциальные и городские районы менее чем в 75 словах",
"收货人姓名":"Наименованиегрузополучателя",
"不能为昵称、X先生、X小姐等，请使用真实姓名":"Никаких прозвищ, мистер икс, мисс икс и т.д. пожалуйста, используйте настоящие имена",
"手机号":"Номер телефона",
"手机号码、电话号码必须填一项":"Номер телефона, номер телефона должны быть заполнены",
"保存地址":"Сохранить адрес",
"取消":"отмен",
//coupon.vue  
"可使用的优惠券":"Доступные купоны",
"没有数据":"Данных нет.",
"折":"скидк",
"免邮费":"Бесплатно.",
"可用":"доступн",
"满":"полн",
"立即使用":"Немедленно.",
"已使用的优惠券":"Использованные купоны",
"已使用":"Используется.",
"已失效的优惠券":"Просроченные купоны",
"已失效":"He работает.",
"立即使用":"Немедленно.",

//personal-left.vue
"个人中心":"Индивидуальный центр",
"我的订单":"Мои заказы",
"我的优惠券":"Мой купон",
"我的发票":"Мой счет-фактура",
"账号管理":"Управление учетными записями",
"我的收货地址":"Мой адрес доставки",
"我的积分":"Мой адрес доставки",
"足迹":"",

//seckill.vue
// "骏芯秒杀":"骏芯秒杀",
"点场":"B-нибуд",
// "距开始":"距开始",
// "距结束":"距结束",
"最新帖子":"Последний пост.",
"更多":"больш",

//views/lensMod/index.nue
"品牌":"бренд",
"分类":"классификац",
//login.vue
"注册账号":"Регистрационный номер.",
"输入手机号":"Введите номер телефона.",
"请输入验证码":"Введите код веридан",
"获取短信验证码":"Достань код подтверждения CMC",
"请输入密码":"Введите пароль.",
"登录/注册":"Вход/регистрация",
"同意网站":"Согласиться на сайт",
"《隐私权协议》":"《Соглашение o праве на частную жизнь》",
"《骏芯平台服务协议》":"《Протокол обслуживания платформы хаяо》",
"和":"и",
"已有账号，去":"Номер счета готов",
// "登录":"登录",
"已阅读":"Прочитано.",

//resetpwd.vue
"忘记密码":"Забудь пароль.",
"请输入新密码":"Введите новый пароль",
"记得密码，去":"Запомни пароль",

//signin.vue

"密码登录":"Пароль доступа.",
"验证码登录":"Вход в систему",

//goods.vue
"型号":"Модель",
"品牌":"Бренд",
"类目":"Категория",
"批次":"Партии",
"增量":"Приращение",
"数据手册":"Справочник по данным",
"点击下载":"Нажмите для загрузки",
"暂未添加,敬请期待":"Ожидайте c нетерпением",
"阶梯数":"Количество ступеней",
"阶梯价格":"Цена ступени",
"可替代产品":"Альтернативные продукты",
"描述":"Описание ",
"现货库存:":"спот",
"起订量":"Минимальный заказ",
"近期销量":"Недавние продажи",
"采购数量":"Количество закупок",
"总价":"Общая сумма",
"加入购物车":"Общая сумма",
"立即购买":"Общая сумма",
"产品介绍":"Описание продукта",
"规格":"спецификац",
"参数":"параметр",
"PDF数据手册":"PDF данные",
"数据手册下载":" Скачать PDF",
"上一页":"Ha последней странице.",
"下一页":"Ha следующей странице.",
"加入购物车成功!":"Успех в присоединении к тележке!",
"进入":"в",
"购物车结算":"Расплата за тележку",

//details.vue

"热门产品":"Горячий товар.",
"价格":"цен",

//feedback.nue
"骏芯视频":"Видео хаяо",
//list.vue
"首页":"Главн страниц",
//newsInfo.vue
"问题反馈:":"Обратная связь c вопросом:",
"上传图片":"Загрузи фото.",
"联系方式：":"Контактная информация.:",
"邮箱：":"Почтов ящик：",
"立即反馈":"Немедленная обратная связь",
"下载":"загрузк",
//find.vue
"验证身份":"Идентификация.",
"修改手机":"Измени телефон.",
"完成":"законч",
"手机验证码验证 账号":"Проверка по сотовому аккаунт",
"为确认是你本人操作，请完成以下验证":"Для подтверждения, что это ваша операция, завершите следующую проверку",
"手机验证码":"Проверка телефона.",
"发送验证码":"Посылать код проверки",
"确定":"увер",
"更改手机号":"Смени номер телефона.",
"绑定成功":"Связь завершена.",
"手机号更改成功":"Изменение номера телефона успешно",
//findCode.vue

"设置新密码":"Новый пароль.",
"账号188******78为确认是你本人操作，请完成以下验证":"что это ваша операция",
"新密码设置成功":"Новый пароль сработал",

"我的足迹":"我的足迹",
//personal/index.vue

"点击编辑":"редактировать",
"绑定手机号":"Привязка номера мобильного телефона",
"昵称":"прозвище",
"签名":"Подпись",
"邮箱":"почтовый ящик",
"学历":"Образование",
"公司名称":"Название компании",
"公司名称:":"Название компании:",
"请输入昵称":"Пожалуйста, введите имя.",
"请选择":"Выбирай.",
"请输入签名":"Пожалуйста, введите подпись.",
"请输入公司名称":"Введите название компании",
"保存提交":"Сохраните отправку",
"点击添加":"добавля",
//integral.vue
"全部积分":"Bce баллы",
"签到积分":"Интеграл при входе",
"我的积分":"Мои баллы",
"进入兑换专区":"Перейти в зону погашения",
"来源/用途":"Источник/применение",
"积分":"интегральн",
"剩余积分":"Остаточный интеграл",
"时间":"врем",
"获取积分":"Получить интеграл",
"扣除积分记录":"Отчет o вычете интегралов",

//myFp.vue
"我的发票列表":"Мой список счетов-фактур",
"没有数据":"Нет данных",
"对应商品订单":"Соответствовать заказу на товар",
"查看详情":"Проверьте детали.",
"发票抬头":"Счет вверх.",
"开票金额(元)":"Сумма штрафа (юань)",
"发票税率(%)":"Ставка налога на счета (%)",
"发票内容":"Счета.",
"备注":"примечан",
"审核中":"Проверка.",
"已出票":"Билет выписан.",

//order.vue
"已取消":"Отменено",
"待支付":"Подлежит оплате",
"待付款":"Ожидание оплаты",
"所有订单":"Bce заказы",
"商城":"Торговый центр",
"单价（含税）":"Единичная цена",
"数量":"Количество",
"总计（元）":"Bce вместе.",
"订单状态":"Операция",
"操作":"операцион",
"订单号":"Номер заказа",
"下单时间":"B следующий раз",
"普通商品":"Обычные продукты",
"秒杀商品":"Секундное убийство товара",
"爆款商品":"Взорванные товары",
"新品":"нов",
"成品":"Готов продукц",
"积分商品":"Интегральный товар",
"去支付":"Выплатить",
"已完成":"Готово",
"查看订单":"Проверь приказ",
"确认收货":"Подтвердить получение",
"替代方案":"Альтернативы",
"再次购买":"Еще раз",
"待发货":"Приготовиться",
"待评论":"Комментарии",
"售后订单":"Послепродажный заказ",
"待收货":"Ждем товар",
"可开票":"Выписка.",
"去开票":"Выпиши чек.",
"已提交,点击查看":"Подано и проверено",
"开票":"Оформить счет-фактуру",
"金额":"сумм",
"元":"доллар",
"开票主体":"Выпишите чек",
"请输入开票主体":"Введите, пожалуйста, номер рецепта",
"发票类型":"Тип счета",
"请选择发票类型":"Пожалуйста, выберите тип счета",
"税率":"ставк",
"发票抬头":"Счет вверх.",
"请输入发票抬头":"Введите счёт, пожалуйста",
"开票内容":"Выписывать содержание",
"请输入开票内容":"Введите, пожалуйста, содержимое квитанции",
"请输入备注":"Пожалуйста, введите примечание",
"确认开票":"Подтверждаю.",
//orderInfo.vue

"1、提交订单":"Представление заказов",
"2、付款成功":"Успешные платежи",
"3、仓库发货":"Поставка co склада",
"4、确认收货":"Подтвердить получение",
"当前状态":"Текущее состояние",
"立即兑换":"Меняйте немедленно.",
"立即支付":"Оплатить сейчас",
"删除订单":"Удалить заказ",
"立即收货":"Немедленно.",
"订单详情":"Подробности заказа",
"订单收货地址":"Адрес получения заказа",
"物流单号":"Логистический номер",
"订单类型":"Тип заказа",
"付款积分":"Интеграл платежа",
"付款金额":"Сумма платежа",
"是否开票":"Выписывать или нет",
"已提交":"Подано.",
"订单":"Заказы",
"商品信息":"Информация o продукте",
"分类/描述/参数品牌":"Параметр",
"优惠":"Льготный",
"小计":"Итого",
"申请退款":"Вернуть деньги",
"已申请退款":"Вернуть деньги",
"退货":"возврат",
"已退款":"Возврат.",
"商品应付总计":"Общая сумма, подлежащая уплате за товар",
"运费":"фрахт",
"优惠券抵扣金额":"Сумма вычета по купонам",
"应付积分":"Обрабатывать интеграл",
"应付金额":"Сумма к оплате",
"退货信息":"Информация o возврате",

//orderSucceed.vue
"您的订单已支付成功":"Ваш заказ был оплачен успешно",
"安全提醒:请不要将银行卡、密码、手机验证码提供给他人":"Напоминаем o безопасности: пожалуйста, не предлагайте другим банковскую карту, пароль, идентификационный код сотового телефона",
// "查看我的订单":"Проверь мой заказ",
//allProducts.vue

"功能":"функц",
"原装正品":"оригинал",
"闪电配送":"Распределение молний.",
"售后无忧":"После продажи, без проблем",
"商品总数":"Товарный фонд",
"按钮":"кнопк",
"供应商型号":"Модель поставщика",
"类别":"категор",
"厂牌":"лейбл",
"货期:内地 1工作日":"Срок поставки: 1 рабочий день на материке",
"价格梯度":"Градиент цены",
"库存":"инвентаризац",
"合计":"совокупн",

//endProduct.vue
"成品方案":"Время релиза.",
"名称":"назван",
"简介":"профил",
"文档版本":"Документ.",
"发布时间":"Время релиза.",
"新品推荐":"Рекомендации по новому продукту",
"即将开始":"Начинается",
"已经结束":"Все кончено",
"正在秒杀":"Сейчас",
"距离结束":"Конец дистанции",
"已售":"прода",
"已结束":"Все кончено",
"未开始":"Еще нет",
"立即抢购":"Возьми это сейчас",

//account.vue
"收":"за",
"提交订单":"Представлять приказ",
"返回购物车修改":"Вернись в тележку с модификациями",
"应付":"Справ с",
"优惠券抵扣金额":"Сумма скидок на купоны",
"优惠券折扣":"Скидка на купоны",
"商品券":"Товарный билет",
"立即发货":"Немедленно",
"货期":"Груз период",
"确认商品信息":"Подтвердить информацию о товаре",

"订单提交成功，现在只差最后一步啦!":"Приказ был выполнен. Остался последний шаг!",
"支付金额":"Сумма выплаты",
"积分支付":"Интегральная оплата",

"去结算":"Иди разберись",
"总计（不含运费）":"Суммирование (без платы за доставку)",
"件":"Пункт",
"已选商品":"Выбрать товар",
"全部":"все",
"删除选中商品":"Удалять товар",
"删除":"удал",
"图片":"картинк",
"购物车内暂时没有商品，您可以":"В торговых вагонах временно нет товаров, которые можно купить",
"去首页查找、挑选您需要的产品":"Ищите на первой странице и выбирайте товары, которые вам нужны",

"领券立减":"Минус талоны",
"代理分销品牌":"Торговая марка",
"元可用":"Доступно",
"还剩下":"Осталось",
"张":"на",
"立即领取":"Получить немедленно",

"我是贸易商":"Я торговец",
"我是工厂":"Я на фабрике",
"我是代理商":"Я агент",
"我是原厂":"Я был на фабрике",
"联系方式:":"Контактная информация:",
"类型":"тип:",
"联系人:":"Контакт:",
"申请入驻":"Подать заявку на онбординг",
"立即申请":"Немедленно",

}


// WEBPACK FOOTER //
// ./src/lang/ru.js